import React from 'react';
import { useTranslation } from 'react-i18next';
import './curve-theme.css';

export type PriorityFilterItem = {
  id: number | string;
  label: string;
};

type PriorityFilterProps = {
  items: PriorityFilterItem[];
  value: string;
  onChange: (value: string) => void;
};

export function PriorityFilter({ items, value, onChange }: PriorityFilterProps) {
  const { t } = useTranslation();
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        height: '28px',
        border: '1px solid var(--curve-border, #E5E5E5)',
        borderRadius: 'var(--curve-radius-sm, 4px)',
        padding: '0 6px',
        fontSize: 'var(--curve-text-xs, 12px)',
        color: value ? 'var(--curve-text-dark, #1E293B)' : 'var(--curve-text-muted, #64748B)',
        background: 'var(--curve-bg-white, #FFFFFF)',
        cursor: 'pointer',
        outline: 'none',
        flexShrink: 0,
        appearance: 'auto',
      }}
    >
      <option value="">{t('SearchBar.priority_placeholder')}</option>
      {items.map((item) => (
        <option key={item.id} value={String(item.id)}>
          {item.label}
        </option>
      ))}
    </select>
  );
}
